// src/pages/AdministrationPage.tsx
import React, { useEffect, useState } from "react";
import SideMenu from "../../components/sideMenu";
import { useNavigate } from "react-router-dom";
import { roleService } from "../../services/roleService";
import Loading from "../../components/loading";

const AdministrationPage: React.FC = () => {
  const [effective, setEffective] = useState<Record<string, boolean>>({});
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      try {
        const [effectiveRes] = await Promise.all([
          roleService.getMyEffectivePermissions(),
        ]);

        console.log(effectiveRes);

        setEffective(effectiveRes.effective || {});
      } catch (err) {
        console.error("[AdministrationPage] init error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, []);

  const canViewOrg = effective["organization.view"] || false;
  const canViewDevice = effective["device.view"] || false;
  const canViewUser = effective["user.view"] || false;
  const canViewRole = effective["roles.manage"] || false;

  const cards = [
    {
      title: "Organizations",
      description: "Create, update and delete organizations.",
      action: () => navigate("/admin/organizations"),
      visible: canViewOrg,
    },
    {
      title: "Devices",
      description: "Manage devices under each organization.",
      action: () => navigate("/admin/devices"),
      visible: canViewDevice,
    },
    {
      title: "Users",
      description: "Manage users per organization.",
      action: () => navigate("/admin/users"),
      visible: canViewUser,
    },
    {
      title: "Role Permissions",
      description: "Configure what each role can do per organization.",
      action: () => navigate("/admin/roles"),
      visible: canViewRole,
    },
  ];

  return (
    <SideMenu active={3}>
      <div className="relative">
        {isLoading && <Loading />}

        <div className="flex">
          <div className="container p-4 pt-8 xl:pt-4">
            <h2 className="text-2xl font-bold mb-4">Administration</h2>
            <p className="text-gray-600 mb-8">
              Manage organizations, devices, users and their permissions.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {cards.map((card) => (
                <div
                  key={card.title}
                  className={`border rounded-xl shadow-sm p-5 hover:shadow-lg transition cursor-pointer bg-white
                  ${card.visible ? "block" : "hidden"}`}
                  onClick={card.action}
                >
                  <h3 className="font-semibold text-lg mb-2">{card.title}</h3>
                  <p className="text-sm text-gray-500 mb-4">
                    {card.description}
                  </p>
                  <button className="px-4 py-2 rounded-lg bg-green text-white text-sm">
                    Manage {card.title}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};

export default AdministrationPage;
